import {authRole} from '../../../shared/constants/AppConst';

export const getUserFromAuth0 = (user) => {
  if (user)
    return {
      id: 1,
      uid: user.sub,
      full_name: user.username,
      email: user.email_address,
      phone: user.mobile_number,
      role: authRole.user,
      company: user.business.business_name,
      business: user.business,
    };
  return user;
};

export const getUserFromFirebase = (user) => {
  if (user)
    return {
      id: 1,
      uid: user.uid,
      full_name: user.username ? user.username : 'Crema User',
      email: user.email_address,
      photoURL: '/assets/images/avatar/A11.jpg',
      role: authRole.user,
      phone: user.mobile_number,
    };
  return user;
};
export const getUserFromAWS = (user) => {
  if (user)
    return {
      id: 1,
      uid: user.username,
      full_name: user.attributes.name ? user.attributes.name : 'Crema User',
      email: user.attributes.email,

      role: authRole.user,
    };
  return user;
};

export const getUserFromJwtAuth = (user) => {
  if (user)
    return {
      id: user.id,
      username: user.name || user.username,
      full_name: user.name || user.full_name,
      company: user.business?.business_name || 'Al-Bireh Municipality', // Default to municipality name
      business: user.business || {business_name: 'Al-Bireh Municipality'},
      email: user.email || user.email_address,
      phone: user.phone || user.phone_number,
      roles: user.roles || [],
      is_super_admin: user.is_super_admin || false,
      is_active: user.is_active !== undefined ? user.is_active : true, // Include is_active status
      permissions: user.permissions || [],
      role: user.role || 'user',
      agreement_status: user.agreement_status || null,
      created_at: user.created_at,
      timezone: user.timezone,
    };

  return user;
};
